module.exports = __webpack_public_path__ + "static/media/safeExchange.81b8ea73.jpg";